import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CreateCustomerInvoiceApi,
  GetStockStatsApi,
  GetCustomerInvoiceApi,
  GetCustomerInvoiceByIdApi,
  GetCustomerPaymentByIdApi,
  GetCompanyPaymentByIdApi,
} from "../../ApiRequests";

export const fetchCompanyPayments = createAsyncThunk(
  "fetch/CompanyPayments",
  async (id) => {
    try {
      let response;
      if (id) response = await GetCompanyPaymentByIdApi(id);
      else response = await GetCustomerInvoiceApi();

      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CompanyPaymentSlice = createSlice({
  name: "CompanyPayment",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyPayments.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCompanyPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCompanyPayments.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CompanyPaymentSlice.reducer;
